import { useMutation } from "@apollo/client/react";
import { BULK_DELETE_INVOICES } from "../../mutations/invoices/bulkDeleteInvoices";
import GET_CLIENTS_WITH_INVOICES from "../../queries/invoices/getClientsWithInvoices";
import GET_CLIENT_INVOICES from "../../queries/invoices/getClientInvoices";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";

export const useBulkDeleteInvoices = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [bulkDeleteInvoices, { data, loading, error }] = useMutation(
    BULK_DELETE_INVOICES,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [
        GET_CLIENTS_WITH_INVOICES,
        GET_CLIENT_INVOICES,
        GET_INVOICE_LATEST_VALIDATION_RESULT,
      ],
      awaitRefetchQueries: true,
    },
  );

  return { bulkDeleteInvoices, data, loading, error };
};
